import React, { useState } from 'react';
import { Calendar, CheckCircle, User, Clock, Sparkles, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../components/MobileLayout';
import { PianificaPuliziaWizard } from '../components/PianificaPuliziaWizard';
import { Tabs } from '../components/ui/Tabs';
export function PuliziePage() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'gestione' | 'opportunita'>('gestione');
  // Mock data for upcoming cleanings
  const prossimePulizie = [{
    id: '1',
    property: 'Villa Sunset',
    date: 'Mer 17 Gen',
    time: '11:00 - 15:00',
    status: 'in_corso',
    cleaner: 'Francesca N.',
    cleanerImg: 'https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png',
    isShareable: true
  }, {
    id: '2',
    property: 'Villa Sunset',
    date: 'Ven 19 Gen',
    time: '12:00 - 14:30',
    status: 'pianificata',
    cleaner: 'Roberto F.',
    cleanerImg: '',
    isShareable: false
  }];
  // Mock data for completed cleanings
  const pulizieCompletate = [{
    id: '3',
    property: 'Villa Sunset',
    date: 'Lun 15 Gen',
    duration: '3h 30min',
    cleaner: 'Francesca N.',
    aiScore: 98,
    isShareable: true
  }, {
    id: '4',
    property: 'Villa Sunset',
    date: 'Ven 12 Gen',
    duration: '4h',
    cleaner: 'Roberto F.',
    aiScore: 100,
    isShareable: false
  }];
  const shareableProssime = prossimePulizie.filter(p => p.isShareable);
  const shareableCompletate = pulizieCompletate.filter(p => p.isShareable);
  const totalShareable = shareableProssime.length + shareableCompletate.length;
  return <MobileLayout data-id="element-4034">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-4035">
        <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-4036">
          Pulizie
        </h1>
      </div>

      {/* Tabs */}
      <Tabs className="mb-6" value={activeTab} onValueChange={id => setActiveTab(id as 'gestione' | 'opportunita')} items={[{
      id: 'gestione',
      label: 'Gestione'
    }, {
      id: 'opportunita',
      label: 'Opportunità',
      badge: totalShareable > 0 ? <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold bg-coral text-white rounded-full" data-id="element-4038">
                  {totalShareable}
                </span> : undefined
    }]} data-id="element-4037" />

      {/* TAB: Gestione */}
      {activeTab === 'gestione' && <>
          {/* In corso / Prossime */}
          <div className="mb-8" data-id="element-4039">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-4040">
              In corso e prossime
            </div>

            <div className="space-y-3" data-id="element-4041">
              {prossimePulizie.map(pulizia => {
            const isInProgress = pulizia.status === 'in_corso';
            return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-4042">
                    <div className="flex justify-between items-start mb-3" data-id="element-4043">
                      <div data-id="element-4044">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-4045">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-4046">
                          <span className="flex items-center gap-1" data-id="element-4047">
                            <Calendar size={12} data-id="element-4048" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-4049">
                            <Clock size={12} data-id="element-4050" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-4051">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-4052">
                      <div className="flex items-center gap-2" data-id="element-4053">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-4054" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-4055">
                            <User size={14} className="text-muted-foreground" data-id="element-4056" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-4057">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-4058" />
                    </div>
                  </Link>;
          })}
            </div>
          </div>

          {/* Completate */}
          <div className="mb-6" data-id="element-4059">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-4060">
              Completate di recente
            </div>

            <div className="space-y-3" data-id="element-4061">
              {pulizieCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-4062">
                  <div data-id="element-4063">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-4064">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-4065">
                      <span className="flex items-center gap-1" data-id="element-4066">
                        <Calendar size={12} data-id="element-4067" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4068">
                        <Clock size={12} data-id="element-4069" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-4070">
                    <div className="flex flex-col items-end" data-id="element-4071">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-4072">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-4073">
                        <CheckCircle size={12} data-id="element-4074" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-4075" />
                  </div>
                </Link>)}
            </div>
          </div>
        </>}

      {/* TAB: Opportunità */}
      {activeTab === 'opportunita' && <div className="mb-8" data-id="element-4076">
          <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3 flex items-center gap-1.5" data-id="element-4077">
            <Sparkles size={12} className="text-coral" data-id="element-4078" />
            Pulizie condivisibili
          </div>

          {totalShareable === 0 ? <div className="bg-white border border-border rounded-xl p-8 text-center" data-id="element-4079">
              <p className="text-sm text-muted-foreground" data-id="element-4080">
                Nessuna pulizia condivisibile al momento.
              </p>
            </div> : <div className="space-y-3" data-id="element-4081">
              {shareableProssime.map(pulizia => {
          const isInProgress = pulizia.status === 'in_corso';
          return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-4082">
                    <div className="flex justify-between items-start mb-3" data-id="element-4083">
                      <div data-id="element-4084">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-4085">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-4086">
                          <span className="flex items-center gap-1" data-id="element-4087">
                            <Calendar size={12} data-id="element-4088" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-4089">
                            <Clock size={12} data-id="element-4090" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-4091">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-4092">
                      <div className="flex items-center gap-2" data-id="element-4093">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-4094" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-4095">
                            <User size={14} className="text-muted-foreground" data-id="element-4096" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-4097">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-4098" />
                    </div>
                  </Link>;
        })}

              {shareableCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-4099">
                  <div data-id="element-4100">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-4101">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-4102">
                      <span className="flex items-center gap-1" data-id="element-4103">
                        <Calendar size={12} data-id="element-4104" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-4105">
                        <Clock size={12} data-id="element-4106" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-4107">
                    <div className="flex flex-col items-end" data-id="element-4108">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-4109">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-4110">
                        <CheckCircle size={12} data-id="element-4111" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-4112" />
                  </div>
                </Link>)}
            </div>}
        </div>}

      {/* Wizard Modal */}
      <PianificaPuliziaWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-4113" />
    </MobileLayout>;
}